import axios from "axios";
// import alert from "@/plugins/AlertMessages.js";

export default {
  getSliders({ dispatch, commit }, data) {
    axios
      .get("client/Slider?" + data)
      .then((res) => {
        commit("setSliders", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBlogs({ dispatch, commit }, data) {
    axios
      .get("client/Blog/LoadFavorites?" + data)
      .then((res) => {
        commit("setBlogs", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getMedias({ dispatch, commit }, data) {
    axios
      .get("client/Media/LoadFavorites?" + data)
      .then((res) => {
        commit("setMedias", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getSounds({ dispatch, commit }, data) {
    axios
      .get("client/Sound/LoadFavorites?" + data)
      .then((res) => {
        commit("setSounds", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getPhotos({ dispatch, commit }, data) {
    axios
      .get("client/Photo/LoadFavorites?" + data)
      .then((res) => {
        commit("setPhotos", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },

  getBooks({ dispatch, commit }, data) {
    axios
      .get("client/Book/LoadFavorites?" + data)
      .then((res) => {
        commit("setBooks", res.data.data);
      })
      .catch((error) => {
        dispatch("errorGETHandler", error, { root: true });
      });
  },
};
